import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ListingFollowup({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h2 className="blue-heading">-review this report</h2>
          </Col>
          <Col span={24}>
            <h2 className="blue-heading">
              -review applications being processed
            </h2>
          </Col>
          <Col span={24}>
            <h2 className="blue-heading">
              -if there is sufficient interest delay the due date of this task
              if no interest send email below
            </h2>
          </Col>
          <Col span={24}>
            <h2>
              send this email to the owner in appfolio - include the property
              address in the subject line if there are no viable applications
              processing.
            </h2>
          </Col>
          <Col span={24}>
            <p>
              Your property has now been on the market for an extended period.
              At this point we highly recommend a price change. This will help
              to generate renewed interest and potentially an applicant we can
              approve. If you are ready to make a price change just let us know
              and we can get it adjusted now! We generally recommend between a
              $25 and $50 price drop. You also may want to consider our Security
              Deposit alternative offering if you do not already have that on
              your listing. Let me know if you need more info on that.
            </p>
          </Col>
          <Col span={24}>
            <h1 className="blue-heading">
              Once you have a reply from the owner adjust the listing
              accordingly.
            </h1>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ListingFollowup;
